import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  headingNews: {
    id: 'views.NewsAndEvents.heading.news',
    defaultMessage: 'Aktualności:'
  },
  headingEvents: {
    id: 'views.NewsAndEvents.heading.events',
    defaultMessage: 'Wydarzenia:'
  },
  headingAllNews: {
    id: 'views.NewsAndEvents.heading.allNews',
    defaultMessage: 'Zobacz wszystkie'
  }
});



// WEBPACK FOOTER //
// ./src/views/Home/Sections/NewsAndEvents/NewsAndEvents.intl.js